export const Terms = ({ terms }: { terms: string | undefined }) => {
  if (!terms) {
    return null;
  }
  return <span className="text-center text-xs text-gray-500">{terms}</span>;
};
